import Const from 'constants';
import Action from 'actions';

const PlayerPositionStacking = {
    setPlayerPositionStackingFromStorage(data) {
        return {
            type: Const.PLAYER_POSITION_STACKING_SET_DATA_FROM_STORAGE,
            data,
        };
    },

    usePlayerPositionStacking(use) {
        return {
            type: Const.PLAYER_POSITION_STACKING_SET_IS_USED,
            use,
        };
    },

    useSecondaryStack(use) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_USED,
                use,
            });
            dispatch(this.savePlayerPositionStackingToStorage());
        };
    },

    setSecondaryStackIsForced(isChecked) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_FORCED,
                isChecked,
            });
            dispatch(this.savePlayerPositionStackingToStorage());
        };
    },

    setAllowOverlapPrimaryAndSecondaryStacks(isChecked) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_POSITION_STACKING_SET_ALLOW_OVERLAP_PRIMARY_AND_SECONDARY_STACKS,
                isChecked,
            });
            dispatch(this.savePlayerPositionStackingToStorage());
        };
    },

    setSecondaryStackCombinationTypeOfPlayerPositionStacking(combinationType, value) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE,
                combinationType,
                value,
            });
            dispatch(this.savePlayerPositionStackingToStorage());
        };
    },

    addItemToPlayerPositionStacking(item) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_POSITION_STACKING_ADD_ITEM,
                item,
            });
            dispatch(this.savePlayerPositionStackingToStorage());
        };
    },

    removeItemOfPlayerPositionStacking(itemId) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_POSITION_STACKING_REMOVE_ITEM,
                itemId,
            });
            dispatch(this.savePlayerPositionStackingToStorage());
        };
    },

    savePlayerPositionStackingToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('playerPositionStacking', function (state) {
                    const {playerPositionStacking} = state;
                    return playerPositionStacking.all();
                }),
            );
        };
    },
};

export default Object.assign(Action, PlayerPositionStacking);
